export default "__VITE_ASSET__DtGv9lQR__"